/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import {AppState} from "../../../redux/reducers/rootReducer"
import Error from "../../../@biocrates-common-repo/core/models/error"

export function selectIsErrorReportVisible(state: AppState): boolean {
    return state.common.errorReport.isVisible
}

export function selectErrorForErrorReport(state: AppState): Error | undefined {
    return state.common.errorReport.error
}
